import { Component, input } from '@angular/core';

export type AdminButtonVariant =
  | 'primary'
  | 'accent'
  | 'secondary'
  | 'ghost'
  | 'danger'
  | 'success'
  | 'cancel';

@Component({
  selector: 'app-admin-button',
  standalone: true,
  host: {
    class: 'cg-admin-button-host',
    style: 'display: inline-flex',
  },
  template: `
    <button
      [type]="type()"
      [class]="buttonClass()"
      [disabled]="disabled()"
      [attr.aria-disabled]="disabled() ? true : null"
    >
      <ng-content />
    </button>
  `,
})
export class AdminButtonComponent {
  readonly variant = input<AdminButtonVariant>('secondary');
  readonly type = input<'button' | 'submit' | 'reset'>('button');
  readonly disabled = input(false);

  buttonClass(): string {
    const variant = this.variant();
    const map: Record<AdminButtonVariant, string> = {
      primary: 'cg-btn cg-btn-primary',
      accent: 'cg-btn cg-btn-accent',
      secondary: 'cg-btn cg-btn-secondary',
      ghost: 'cg-btn cg-btn-ghost',
      danger: 'cg-btn cg-btn-danger',
      success: 'cg-btn cg-btn-success',
      cancel: 'cg-btn cg-btn-cancel',
    };
    return map[variant];
  }
}
